






















import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class InsertionModal extends Vue {
    // コールバック
    @Prop() private callback! : (button : string) => void;

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }
    
    onCreateInsertion()
    {
        DebugHelper.trace("表を新規作成");

        this.callback("createInsertion");
    }
    onImportInsertion()
    {
        DebugHelper.trace("表を読み込む");

        this.callback("importInsertion");
    }

    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
